import z from 'zod';
import { SkillSchema } from './skillSchema';
export const CreateUserSkillSchema = z
    .object({
    skill: SkillSchema,
    level: z.object({
        value: z.enum(['professional', 'advanced', 'basic']),
        label: z.string()
    }, { required_error: 'REQUIRED_INPUT' }),
    description: z.string().max(500).optional().describe('Skill Description')
})
    .describe('Create User Skill object with skill, level and description');
//# sourceMappingURL=createUserSkillSchema.js.map